import { Box } from '@mui/material';
// import Register from '../components/HomeSection/Register';
import LatestNews from '../components/HomeSection/LatestNews';
import Statistics from '../components/HomeSection/Statistics';
import CommunityJoin from '../components/HomeSection/CommunityJoin';
import UpcomingEvents from '../components/HomeSection/UpcomingEvents';
import RegistrationForm from '../components/HomeSection/RegistrationForm';
import HomeSlider from '../components/PremiumHeroSlider/PremiumHeroSlider';

const Home = () => {
  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <HomeSlider />
      <CommunityJoin />
      <LatestNews />
      <UpcomingEvents />
      <Statistics />
      <RegistrationForm />
      {/* <Register /> */}
    </Box>
  );
};

export default Home;
